import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import TopBottomLayout from "./TopBottomLayout";
import { useRevenueCatAuth } from "../Context/RevenueCatContext/RevenueCatContext";
import { usePaywallStore } from "../zustandStore/paywallStore";
import { useSupabaseAuth } from "../Context/AuthContext/AuthContext";

interface ChatbotWrapperProps {
  children: ReactNode;
}

const ChatbotWrapper = ({ children }: ChatbotWrapperProps) => {
  const { isSubscribed } = useRevenueCatAuth();
  const { checkAndResetPaywallIfExpired } = usePaywallStore();
  const location = useLocation();
  const { useAuthStore } = useSupabaseAuth();
  const profile = useAuthStore((state: any) => state.profile);

  // Get showPaywall from navigation state
  const showPaywall = location.state?.showPaywall || false;

  // Check if paywall should be reset and get the current state
  const hasSeenPaywall = checkAndResetPaywallIfExpired();

  // Updated condition: !isSubscribed && !hasSeenPaywall && showPaywall
  if (!isSubscribed && !hasSeenPaywall && showPaywall && profile?.hard_paywall && !profile?.is_super_user) {
    return (
      <Navigate
        to="/chatbot-paywall-v2"
        replace
        state={{
          HasPaywallSeen: true,
        }}
      />
    );
  }

  return <TopBottomLayout>{children}</TopBottomLayout>;
};

export default ChatbotWrapper;
